import { aiApiNestingaleToUpload, axiosObj,axiosInstanceApiNestingale } from '@/app/lib/axios';
import { Design } from '@/app/lib/types/stypes';

export const API_CONFIG = {
    UPLOAD_ENDPOINT: '/v1/api/rawProducts',
    HEADERS: {
      // "Supplier-Id": typeof localStorage  != "undefined"  && localStorage.getItem("cId"),
      // "Supplier-Id": "f67dcdb5-7806-4063-ae08-18127a83eddf",
      'Content-Type': 'multipart/form-data',
      //'origin': window.location.hostname+":"+ window.location.port
    }
};

// export const API_CONFIG = {
//   UPLOAD_ENDPOINT: 'uploader/v2/upload?AlbumID=123071849447070&Retry=N&redEye=false&autoRotate=true&colorCorrect=false&ImageCompression=N&SESSION_ID=57502310703070&Src=JQK',
//   HEADERS: {
//     'Content-Type': 'multipart/form-data',
//   }
// };

export const uploadDesignFile = async (
    formData: any,
    onUploadProgress: (progressEvent: any ) => void
  ): Promise<Design[]> => {

    const response = await axiosInstanceApiNestingale.post<Design[]>(
      API_CONFIG.UPLOAD_ENDPOINT,
      formData.get('data'),
      {
        onUploadProgress,
        headers: API_CONFIG.HEADERS,
      }
    );
  
    return response.data;
  };

  export const getProductsByUploadId = async (): Promise<any> => {
    const response = await axiosObj.get(`/products`);
    return response.data;
  };